
import React from 'react';
import { Shield, Lock } from 'lucide-react';

const TechnologyRequirements: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Understanding HIPAA's Technology Requirements</h2>
      <p className="mb-6 text-gray-700 leading-relaxed">
        HIPAA (Health Insurance Portability and Accountability Act) consists of several rules that impact healthcare IT infrastructure. The most relevant for technology considerations are:
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="border border-gray-200 rounded-lg p-5 shadow-sm">
          <div className="flex items-center mb-3">
            <Shield className="w-5 h-5 mr-2 text-itmgmt-medium-blue" />
            <h3 className="text-lg font-semibold text-itmgmt-medium-blue">The Security Rule</h3>
          </div>
          <p className="text-gray-700 text-sm">
            Establishes national standards for protecting electronic protected health information (ePHI). This rule requires appropriate administrative, physical, and technical safeguards.
          </p>
        </div>
        <div className="border border-gray-200 rounded-lg p-5 shadow-sm">
          <div className="flex items-center mb-3">
            <Lock className="w-5 h-5 mr-2 text-itmgmt-medium-blue" />
            <h3 className="text-lg font-semibold text-itmgmt-medium-blue">The Privacy Rule</h3>
          </div>
          <p className="text-gray-700 text-sm">
            Sets standards for the protection of individually identifiable health information and determines how and when this information can be disclosed.
          </p>
        </div>
      </div>
    </>
  );
};

export default TechnologyRequirements;
